namespace SorAraBul.PropertyManagement {
    export interface PropertyRestrictionsRow {
        Id?: number;
        PropertyId?: number;
        RestrictionId?: number;
        InsertDate?: string;
        InsertUserId?: number;
        UpdateDate?: string;
        UpdateUserId?: number;
        PropertyPropertyType?: number;
        PropertyPropertyName?: string;
        PropertyAddress?: string;
        PropertyImages?: string;
        PropertyRequestedRentAmount?: number;
        RestrictionName?: string;
        RestrictionPropertyType?: number;
        RestrictionInsertDate?: string;
        RestrictionInsertUserId?: number;
        RestrictionUpdateDate?: string;
        RestrictionUpdateUserId?: number;
        RestrictionIsActive?: number;
    }

    export namespace PropertyRestrictionsRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'PropertyManagement.PropertyRestrictions';
        export const deletePermission = 'Properties:Delete';
        export const insertPermission = 'Properties:Insert';
        export const readPermission = 'Properties:View';
        export const updatePermission = 'Properties:Update';

        export declare const enum Fields {
            Id = "Id",
            PropertyId = "PropertyId",
            RestrictionId = "RestrictionId",
            InsertDate = "InsertDate",
            InsertUserId = "InsertUserId",
            UpdateDate = "UpdateDate",
            UpdateUserId = "UpdateUserId",
            PropertyPropertyType = "PropertyPropertyType",
            PropertyPropertyName = "PropertyPropertyName",
            PropertyAddress = "PropertyAddress",
            PropertyImages = "PropertyImages",
            PropertyRequestedRentAmount = "PropertyRequestedRentAmount",
            RestrictionName = "RestrictionName",
            RestrictionPropertyType = "RestrictionPropertyType",
            RestrictionInsertDate = "RestrictionInsertDate",
            RestrictionInsertUserId = "RestrictionInsertUserId",
            RestrictionUpdateDate = "RestrictionUpdateDate",
            RestrictionUpdateUserId = "RestrictionUpdateUserId",
            RestrictionIsActive = "RestrictionIsActive"
        }
    }
}
